import React from "react";
const SortSpan = () => {
  return <span className="sort-button-hide"></span>;
};

export default SortSpan;
